import { cx } from '@libs/classnames';
import { Placeholder } from '@ui/components/Placeholder/Placeholder';
import { SlimArrowButton } from '@ui/components/SlimArrowButton';

import { Achievement } from '@features/shared/api/typings';
import { PlayerAchievementsListItem } from '@features/user/ui/PlayerAchievementsListItem/PlayerAchievementsListItem';

import styles from './PlayerAchievementsListPreview.module.css';

type Props = {
  className?: string;
  achievements?: Achievement[];
  onShowMore: () => void;
};

export function PlayerAchievementsListPreview({ className, achievements, onShowMore }: Props) {
  return (
    <div className={cx(styles.achievements, className)}>
      <div className={styles.header}>
        <div className={styles.title}>Достижения</div>

        <SlimArrowButton colorPreset="golden" direction="right" size="20" onClick={onShowMore} />
      </div>

      <div className={styles.list}>
        {achievements &&
          achievements.length > 0 &&
          achievements.map((a) => (
            <PlayerAchievementsListItem
              key={a.tournamentCertificate?.tournamentId}
              achievement={a}
              preset="s"
              onClick={onShowMore}
            />
          ))}

        {achievements && achievements.length === 0 && (
          <Placeholder>Пока нет достижений</Placeholder>
        )}
      </div>
    </div>
  );
}
